// Retkipaneelin tilarivit: onko GPS elossa, kuinka tarkka se on ja onko tallennus turvassa.
// "Tallentaa"-teksti yksin ei kerro, tuleeko uusia pisteitä tai onko tieto pysyvästi tallessa.

/** Tarkkuuden raja (m), jota parempi on hyvä; sen yli huomautetaan. */
export const GOOD_ACCURACY_M = 30;
/** Näin kauan (s) viimeisestä pisteestä saa kulua, ennen kuin GPS:n katsotaan olevan hiljaa. */
export const SILENT_AFTER_S = 20;

function ageText(seconds) {
  if (seconds < 5) return "juuri nyt";
  if (seconds < 60) return `${Math.round(seconds)} s sitten`;
  const min = Math.floor(seconds / 60);
  return `${min} min sitten`;
}

/**
 * GPS:n tila: { level: "ok" | "weak" | "silent" | "none", text }.
 * `me` on viimeisin sijainti (latitude, longitude, accuracy, at = vastaanottohetki ms); `now` ms.
 */
export function gpsStatus(me, now = Date.now()) {
  if (!me || !Number.isFinite(me.at)) return { level: "none", text: "Odotetaan GPS-sijaintia…" };
  const age = Math.max(0, (now - me.at) / 1000);
  if (age > SILENT_AFTER_S) return { level: "silent", text: `GPS ei ole päivittynyt ${ageText(age).replace(" sitten", "")}. Viimeinen piste ${ageText(age)}.` };
  const acc = Number.isFinite(me.accuracy) ? Math.round(me.accuracy) : null;
  if (acc == null) return { level: "weak", text: `GPS: tarkkuus tuntematon · päivittyi ${ageText(age)}` };
  return { level: acc > GOOD_ACCURACY_M ? "weak" : "ok", text: `GPS: ±${acc} m · päivittyi ${ageText(age)}` };
}

/**
 * Tallennuksen tila: { level: "ok" | "waiting" | "offline" | "error", text }.
 * `error` (paikallinen tallennus ei onnistu) on vakavin: pisteet voivat kadota, jos sovellus sulkeutuu.
 */
export function saveStatus({ storageFailed = false, pendingPoints = 0, lastError = null } = {}) {
  if (storageFailed) return { level: "error", text: "Puhelimen tallennustila on täynnä, eikä retkeä saada tallennettua. Lopeta retki ja lähetä se palvelimelle mahdollisimman pian." };
  if (pendingPoints > 0 && lastError) return { level: "offline", text: `Ei yhteyttä palvelimeen. ${pendingPoints} sijaintia on tallessa puhelimessa ja lähetetään myöhemmin.` };
  if (pendingPoints > 0) return { level: "waiting", text: `Tallessa puhelimessa. ${pendingPoints} sijaintia odottaa lähetystä.` };
  return { level: "ok", text: "Kaikki sijainnit on lähetetty palvelimelle." };
}
